import { createSplitSwarmFrames } from "../../core/split-swarm-keyframes.js";

export const meta = Object.freeze({
  id: "split-swarm",
  label: "Mini-Orbi-Schwarm-Merge",
  duration: 6800,
  description: "In sieben Mini-Orbis zerplatzen, frei herumhüpfen und nacheinander zu einem wabbernden Orbi verschmelzen.",
  tags: ["body", "split", "swarm", "bounce", "merge", "story", "one-shot", "loopable"],
});

export async function run({ elements, scene, animate }) {
  if (!scene?.miniSwarm || scene.miniBodies.length !== 7 || scene.miniShadows.length !== 7) {
    throw new Error("Die Mini-Orbi-Sequenz benötigt den vollständigen Schwarm in der Stage.");
  }

  const frames = createSplitSwarmFrames();
  const options = { duration: meta.duration, easing: "linear" };
  const animations = [
    animate(elements.actor, frames.mainActor, options),
    animate(elements.shadow, frames.mainShadow, options),
    animate(elements.svg, frames.mainBlob, options),
    animate(scene.swarmRing, frames.burstRing, options),
    ...scene.miniBodies.map((body, index) => animate(body, frames.minis[index].body, options)),
    ...scene.miniShadows.map((shadow, index) => animate(shadow, frames.minis[index].shadow, options)),
    ...scene.swarmSparks.map((spark, index) => animate(spark, frames.sparks[index], options)),
  ];

  await Promise.allSettled(animations.map(({ finished }) => finished));
}
